import { GenericTimeline } from "../../GenericTimeline";
import { Stack } from "@mui/material";

import { useQuestionnaireContext } from "../../../../../contexts/QuestionnaireContext";
import { ExamesHistoryAccordion } from "./ExamesHistoryAccordion";
import { useAttendanceSpecialtyIndex } from "@/hooks/useAttendanceSpecialtyIndex";
import { buildQrDisplayInfo } from "@/utils/resolveAttendanceSpecialty";

export function ExamesHistory({ filter, setFilter, isMobile }: any) {
  const { historyValues } = useQuestionnaireContext();
  const specialtyIndex = useAttendanceSpecialtyIndex();
  const responseEntries = historyValues?.map((el: any) => el?.resource);
  const examsResponses = responseEntries?.map((el: any) => {
    const awnserDate = el?.authored;
    const filterItens = el?.item
      ?.filter((e: any) => e?.text === "Exames Físicos")?.[0]
      ?.item?.find((el: any) => {
        return filter === 0 ? el.text === "Geral" : el?.text !== "Geral";
      });
    const displayInfo = buildQrDisplayInfo(el, specialtyIndex);
    return { awnserDate, filterItens, displayInfo };
  });

  return (
    <Stack>
      <GenericTimeline
        data={examsResponses}
        component={(data: any, index: number) => (
          <ExamesHistoryAccordion
            setFilter={setFilter}
            data={data}
            index={index}
            isMobile={isMobile}
          />
        )}
      />
    </Stack>
  );
}
